import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { adminApiHeader, finalRouteApi } from '../../components/CommonApis/CommonApiUrl';
import AdminBackNavigation from '../../components/CommonComponents/AdminBackNavigation';

const OPS = ['equals','notEquals','in','notIn','greaterThan','lessThan'];
const EFFECTS = ['show','hide','require'];

export default function Conditions(){
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [fields, setFields] = useState([]);
  const [rules, setRules] = useState([]);
  const [form, setForm] = useState({ source_field_id:'', operator:'equals', value:'', target_field_id:'', effect:'show', active:true });

  useEffect(()=>{ let m=true; (async()=>{
    try{
      const feat = await axios.get(`${finalRouteApi}/admin/features/custom-fields`, { headers: adminApiHeader });
      if(!m) return; if(!feat.data?.enabled){ setEnabled(false); setLoading(false); return; } setEnabled(true);
      const [f, r] = await Promise.all([
        axios.get(`${finalRouteApi}/custom-fields`, { headers: adminApiHeader }),
        axios.get(`${finalRouteApi}/custom-fields-conditions`, { headers: adminApiHeader }),
      ]);
      if(!m) return; setFields(f.data?.fields||[]); setRules(r.data?.rules||[]);
    }catch(e){ setError(e?.response?.data?.message||e.message); } finally{ setLoading(false); }
  })(); return ()=>{m=false}; },[]);

  const canSubmit = useMemo(()=> form.source_field_id && form.target_field_id && OPS.includes(form.operator) && EFFECTS.includes(form.effect), [form]);

  const submit = async()=>{
    setError('');
    try{
      const res = await axios.post(`${finalRouteApi}/custom-fields-conditions`, form, { headers: adminApiHeader });
      setRules([res.data.rule, ...rules]);
    }catch(e){ setError(e?.response?.data?.message||e.message); }
  };

  const remove = async(id)=>{
    try{ await axios.delete(`${finalRouteApi}/custom-fields-conditions/${id}`, { headers: adminApiHeader }); setRules(rules.filter(r=> r.id!==id)); }catch(e){ setError(e?.response?.data?.message||e.message); }
  };

  if(loading) return <div>Loading…</div>;
  if(!enabled) return <div>Custom Fields addon is disabled.</div>;

  return (
    <div>
      <AdminBackNavigation path="/custom-fields" text="Back to Custom Fields" />
      <h2>Conditional Rules</h2>
      {error && <div style={{color:'red'}}>{error}</div>}
      <div className="card p-2 mb-3">
        <div className="mb-2">
          <label>Source Field</label>
          <select className="form-control" value={form.source_field_id} onChange={e=> setForm(f=> ({...f, source_field_id: e.target.value}))}>
            <option value=''>-- select --</option>
            {(fields||[]).map(f=> <option value={f.id} key={f.id}>{f.name} ({f.key})</option>)}
          </select>
        </div>
        <div className="mb-2">
          <label>Operator</label>
          <select className="form-control" value={form.operator} onChange={e=> setForm(f=> ({...f, operator: e.target.value}))}>
            {OPS.map(o=> <option key={o} value={o}>{o}</option>)}
          </select>
        </div>
        <div className="mb-2">
          <label>Value</label>
          <input className="form-control" value={form.value} onChange={e=> setForm(f=> ({...f, value: e.target.value}))} />
        </div>
        <div className="mb-2">
          <label>Target Field</label>
          <select className="form-control" value={form.target_field_id} onChange={e=> setForm(f=> ({...f, target_field_id: e.target.value}))}>
            <option value=''>-- select --</option>
            {(fields||[]).map(f=> <option value={f.id} key={f.id}>{f.name} ({f.key})</option>)}
          </select>
        </div>
        <div className="mb-2">
          <label>Effect</label>
          <select className="form-control" value={form.effect} onChange={e=> setForm(f=> ({...f, effect: e.target.value}))}>
            {EFFECTS.map(o=> <option key={o} value={o}>{o}</option>)}
          </select>
        </div>
        <div className="mb-2">
          <label><input type="checkbox" checked={form.active} onChange={e=> setForm(f=> ({...f, active: e.target.checked}))} /> Active</label>
        </div>
        <button className="btn btn-primary" disabled={!canSubmit} onClick={submit}>Create Rule</button>
      </div>

      <table className="table"><thead><tr><th>ID</th><th>Source</th><th>Operator</th><th>Value</th><th>Target</th><th>Effect</th><th>Active</th><th>Actions</th></tr></thead>
        <tbody>
          {(rules||[]).map(r=> (
            <tr key={r.id}>
              <td>{r.id}</td>
              <td>{r.source_field_id}</td>
              <td>{r.operator}</td>
              <td>{r.value}</td>
              <td>{r.target_field_id}</td>
              <td>{r.effect}</td>
              <td>{r.active? 'Yes':'No'}</td>
              <td><button className="btn btn-sm btn-danger" onClick={()=> remove(r.id)}>Delete</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
